import background1 from './background1.png';
import background2 from './background2.png';
import background3 from './background3.png';

export const BACKGROUND_PRESETS = [
  {
    id: 'bg_test1',
    label: '背景 1',
    image: background1,
  },
  {
    id: 'bg_test2',
    label: '背景 2',
    image: background2,
  },
  {
    id: 'bg_test3',
    label: '背景 3',
    image: background3,
  },
];

export const DEFAULT_BACKGROUND_PRESET_ID = BACKGROUND_PRESETS[0].id;
export const BACKGROUND_PRESET_IDS = BACKGROUND_PRESETS.map(({ id }) => id);

export const getBackgroundPreset = (id) =>
  BACKGROUND_PRESETS.find((preset) => preset.id === id) || BACKGROUND_PRESETS[0];
